export const modalNames = {
  TASKS: 'TASKS',
  BUDGET: 'BUDGET',
  LOADING: 'LOADING',
  COMMENTS: 'COMMENTS',
  ASSIGN_USER: 'ASSIGN_USER',
  NEXT_ACTION: 'NEXT_ACTION',
  MANAGE_USERS: 'MANAGE_USERS',
  EDIT_REQUEST: 'EDIT_REQUEST',
  EDIT_CONTACT: 'EDIT_CONTACT',
  EDIT_COMPANY: 'EDIT_COMPANY',
  MANAGE_EMAILS: 'MANAGE_EMAILS',
  MEETING_NOTES: 'MEETING_NOTES',
  CHANGE_STATUS: 'CHANGE_STATUS',
  ADD_NEW_REQUEST: 'ADD_NEW_REQUEST',
  ADD_NEW_CONTACT: 'ADD_NEW_CONTACT',
  ADD_NEW_COMPANY: 'ADD_NEW_COMPANY',
  REQUEST_DETAILS: 'REQUEST_DETAILS',
  ADD_MEETING_NOTES: 'ADD_MEETING_NOTES',
  ASSIGN_USER_TO_TASK: 'ASSIGN_USER_TO_TASK',
  ORGANIZATION_SETTINGS: 'ORGANIZATION_SETTINGS',
  MANAGE_REQUEST_TALENTS: 'MANAGE_REQUEST_TALENTS',
};

export const debounceTime = 300;



// WEBPACK FOOTER //
// ./src/modals/constants.js